/** @flow */

import { beginRequest, completeRequest } from "@store/utils";
import type { EmployeeIdentityState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

export const onGetEmployeeIdentityData = (state: EmployeeIdentityState) => () =>
  startRequest(state);

export const onGetEmployeeIdentityDataSuccess = (state: EmployeeIdentityState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  employeeIdentityData: payload,
});

export const onGetEmployeeIdentityDataError = (state: EmployeeIdentityState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onUpdatePlatformDataSecurityEmployeeIdentity = (state: EmployeeIdentityState) => () =>
  startRequest(state);

export const onUpdatePlatformDataSecurityEmployeeIdentitySuccess = (
  state: EmployeeIdentityState,
) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  employeeIdentityData: payload,
});

export const onUpdatePlatformDataSecurityEmployeeIdentityError = (
  state: EmployeeIdentityState,
) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onGetPlatformDataSecurityEmployeeIdentitySchema = (
  state: EmployeeIdentityState,
) => () => startRequest(state);

export const onGetPlatformDataSecurityEmployeeIdentitySchemaSuccess = (
  state: EmployeeIdentityState,
) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  schema: payload,
});

export const onGetPlatformDataSecurityEmployeeIdentitySchemaError = (
  state: EmployeeIdentityState,
) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});
